module.exports = __webpack_public_path__ + "media/images/faqs/tree-cut-8-b25b33d5c45364b0ff6519e41dbf00a9.svg";